import React, { useEffect, useState } from "react";
import styles from "./Tab.module.scss";
import { RowFlex } from "../flex/RowFlex";
import PropTypes from 'prop-types';
import SvgIcon from "../../utils/svg";

const ImageLabelTab = ({
    className = "",
    options = [],
    selected = null,
    onChange = () => { },
    style={}
}) => {
    const [selectedValue, setSelectedValue] = useState(selected || options[0]?.value);
    const handleSelect = (value) => {
        setSelectedValue(value);

    };
    useEffect(() => {
        onChange(selectedValue);
    }, [selectedValue])
    const getIcon = (option, isSelected) => {
        return (
            <img
                src={isSelected ? option.icon.selected : option.icon.default}
                alt={option.label}
            />
        );
    };
    return (
        <RowFlex className={`${styles.imageLabelTabContainer} ${className}`} style={{...style}}>
            {options.map((option, index) => {
                const isSelected = selectedValue === option.value;
                return (
                    <button
                        key={index}
                        value={option.value}
                        className={`${styles.tab} ${isSelected ? styles.selected : ""}`}
                        onClick={() => handleSelect(option.value)}
                    >
                        {getIcon(option, isSelected)}
                        <div>{option.label}</div>
                    </button>
                );
            })}
        </RowFlex>
    );
};

const LabelTab =  ({
    className = "",
    options = [],
    selected = null,
    onChange = () => { },
    style={}
}) => {
    const [selectedValue, setSelectedValue] = useState(selected || options[0]?.value);
    const handleSelect = (value) => {
        setSelectedValue(value);

    };
    useEffect(() => {
        onChange(selectedValue);
    }, [selectedValue])
    return (
        <RowFlex className={`${styles.LabelTabContainer} ${className}`} style={{...style}}>
            {options.map((option, index) => {
                const isSelected = selectedValue === option.value;
                return (
                    <button
                        key={index}
                        value={option.value}
                        className={`${styles.tab} ${isSelected ? styles.selected : ""}`}
                        onClick={() => handleSelect(option.value)}
                    >
                        <div>{option.label}</div>
                    </button>
                );
            })}
        </RowFlex>
    );
};

const NormalTab = ({
    className = "",
    options = [],
    selected = null,
    onChange = () => { },
    style={}
}) => {

    const [selectedValue, setSelectedValue] = useState(selected || options[0]?.value);

    const handleSelect = (value) => {
        setSelectedValue(value);
    };

    useEffect(() => {
        onChange(selectedValue);
    }, [selectedValue])

    return (
        <RowFlex className={`${styles.normalTabContainer} ${className}`} style={{...style}}>
            {options.map((option, index) => {
                const isSelected = selectedValue === option.value;
                return (
                    <button
                        key={index}
                        value={option.value}
                        className={`${styles.tab} ${isSelected ? styles.selected : ""}`}
                        onClick={() => handleSelect(option.value)}
                    >
                        <div>{option.label}</div>
                    </button>
                );
            })}
        </RowFlex>
    )
};

/**
 * #MenuTab 컴포넌트
 * 
 * `/src/components/tab/Tab.js/NormalTab`
 * 이 컴포넌트는 이미지와 텍스트가 포함된 탭 메뉴를 렌더링합니다.
 * 옵션 배열({ label, value, icon })을 받아 각 탭을 표시하며, 선택된 탭은 강조됩니다.
 */
const MenuTab = ({
    options, selected, onChange,
  }) => {
    return (
      <div className={`${styles.menuTabContainer}`}>
        {options.map((option, idx) => {
          let value, label, icon;
          if (typeof option === 'object') {
            value = option.value;
            label = option.label;
            icon = option.icon;
          } else {
            value = option;
            label = option;
          }
  
          return (
            <button
              key={idx}
              type="button"
              className={`${styles.menuTabItem} ${selected === value ? styles.active : ''}`}
              onClick={() => onChange(value)}
            >
                {icon && (
                    icon.endsWith('.svg') ? (
                        // SVG 파일인 경우, react-svg 라이브러리나 다른 인라인 SVG 렌더링 방법 사용
                        <SvgIcon src={icon} className={styles.menuTabIcon} />
                    ) : (
                        // 그렇지 않으면 일반 img 태그로 렌더링
                        <img src={icon} alt={label} className={styles.menuTabIcon} />
                    )
                )}
                
              {label}
            </button>
          );
        })}
      </div>
    );
  };

MenuTab.propTypes = {
/** 탭 항목 배열 ({ label, value, icon } 형식) */
options: PropTypes.arrayOf(
    PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    icon: PropTypes.string,
    })
),
/** 현재 선택된 탭의 값 */
selected: PropTypes.any,
/** 탭 변경 시 호출되는 함수 */
onChange: PropTypes.func,
};

MenuTab.defaultProps = {
options: [],
selected: null,
onChange: () => {},
};
export { ImageLabelTab ,  LabelTab, NormalTab, MenuTab};
